import { makeStyles } from '@material-ui/core/styles';

const infoStyles = makeStyles((theme) => ({
	seriesImg: {
		'max-width':300
	}
}));

export default infoStyles;